import type { AdminMe, AdminPermission } from '@aitoken/contracts';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { meQuery } from './queries';

export type PermissionRule = AdminPermission | readonly AdminPermission[];

/** 规则为数组时表示“任一权限即可” */
export function hasPermission(
  me: Pick<AdminMe, 'permissions'> | null | undefined,
  rule: PermissionRule,
): boolean {
  if (!me) return false;
  if (typeof rule === 'string') return me.permissions.includes(rule);
  return rule.some((p) => me.permissions.includes(p));
}

/** 已登录区域内使用：me 在路由 beforeLoad 中已确保加载 */
export function useMe(): AdminMe {
  return useSuspenseQuery(meQuery()).data;
}

export function useCan() {
  const me = useMe();
  return useCallback((rule: PermissionRule) => hasPermission(me, rule), [me]);
}

export function useCurrency() {
  return useMe().currency;
}

const ENV_LABEL: Record<string, string> = {
  production: '生产',
  prod: '生产',
  staging: '预发',
  development: '开发',
  dev: '开发',
  local: '本地',
  test: '测试',
};

export function envLabel(env: string): string {
  return ENV_LABEL[env.toLowerCase()] ?? env;
}
